import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const avatars = ['https://cdn.magicpatterns.com/uploads/mbRKnCwDkqEvkym3GvdjNL/landing_avatar_1.png', 'https://cdn.magicpatterns.com/uploads/6UuDsHhoh2H62e5jvF8CBc/valentina.png', 'https://cdn.magicpatterns.com/uploads/7Mw21UA6TRgCxzxE51Y4Py/close-up-smiley-woman-outdoors.jpg'];
export function SocialProofBanner() {
  const [count, setCount] = useState(247);
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => prev + 1);
    }, 8000 + Math.random() * 12000);
    return () => clearInterval(interval);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="w-full bg-primary/5 border-b border-primary/10 py-2.5 px-4" data-id="element-413">
      <div className="max-w-[1280px] mx-auto flex items-center justify-center gap-2 md:gap-3" data-id="element-414">
        <div className="flex -space-x-2 flex-shrink-0" data-id="element-415">
          {avatars.map((src, i) => <img key={i} src={src} alt="" className="w-6 h-6 md:w-7 md:h-7 rounded-full object-cover border-2 border-white" data-id="element-416" />)}
        </div>
        <span className="text-xs md:text-sm font-semibold text-primary text-center leading-tight" data-id="element-417">
          🔥 +
          <motion.span key={count} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="inline-block" data-id="element-418">
            {count}
          </motion.span>{' '}
          personas descargaron el recetario hoy
          <span className="hidden sm:inline" data-id="element-419"> en Argentina</span>
        </span>
      </div>
    </motion.div>;
}